import {html, LitElement} from "lit";
import {CustomerRepository} from "../CustomerRepository.js";
import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";

export class CustomerSelectWidget extends ResolvingLitElement {

    /**
     * @private CustomerRepository
     */
    _customerRepository;

    constructor() {
        super();
        /** @type {Customer[]} **/
        this._customers = [];
    }

    render() {
        return html`<div class="card">
            <form onsubmit="return false;">
                <p>
                    <label for="customer-list">Customers</label>
                    <ul id="customer-list" class="list list--bare">
                        ${this._customers.map(customer => {
                            let checkboxId = 'input-' + customer.id;
                            return html`<li><label for="${checkboxId}"><input type="checkbox" id="${checkboxId}" name="customers" value="${customer.id}" checked>${customer.name}</label></li>`
                        })}
                    </ul>
                </p>
                <p></p>
                <label for="start">Date Range</label>
                <p class="grouped">
                    <input type="date" id="start" name="start">
                    <input type="date" id="end" name="end">
                    <button class="button primary" id="submit-button">Apply</button>
                </p>
                <br>
            </form>
        </div>`
    }

    createRenderRoot() {
        return this;
    }

    connectedCallback() {
        super.connectedCallback();
        this._customerRepository = this._resolve(CustomerRepository);
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);

        let now = new Date();
        let month = ('00' + (now.getMonth()+1)).slice(-2);
        let day = ('00' + (now.getDate())).slice(-2);

        this.renderRoot.querySelector('#start').value = `${now.getFullYear()}-${month}-${day}`;
        this.renderRoot.querySelector('#end').value = `${now.getFullYear()}-${month}-${day}`;

        /** @type {Promise<Customer[]>} **/
        let job = this._publishJob(this._customerRepository.all());
        job.then(customers => {
            this._customers = customers;
            this.requestUpdate();
        });
    }
}

customElements.define('x-customer-select-widget', CustomerSelectWidget);